import { RouteObject } from "react-router-dom";
import CheckoutInProgressPage from "../pages/Checkout/CheckoutInProgressPage";
import StartCheckoutPage from "../pages/Checkout/StartCheckoutPage";

export const checkoutRoutes: RouteObject[] = [
    { path: "/checkout", element: <StartCheckoutPage /> },
    { path: "/checkout/:orderId", element: <CheckoutInProgressPage /> },
];
